<template>
  <router-link class="gallery-entry-link" :class="appearance === 'inline' ? 'mono-link mono-gallery-link' : 'resource-action'" :to="appearance === 'inline' ? '/views?presentation=museum' : '/views?presentation=museum&temporaryPresentation=1'">
    <span>Enter the Gallery</span><GalleryMark interactive />
  </router-link>
</template>

<script>
import GalleryMark from '../view/GalleryMark.vue';
import '../../assets/css/resource-action.css';
export default {
  components: { GalleryMark },
  props: { appearance: { type: String, default: 'button' } },
};
</script>

<style>
.gallery-entry-link .gallery-mark { width: 26.5px; height: 24px; margin-block: -4px; }
.mono-home .mono-gallery-link > .gallery-mark { width: 26.5px; height: 24px; margin-block: -4px; transform: none; transition: none; }
.gallery-entry-link:focus-visible { --gallery-door-scale: .55; --gallery-light-opacity: .35; }
.gallery-entry-link:focus-visible .gallery-mark-door,.gallery-entry-link:focus-visible .gallery-mark-light { transition: none; }
body.dark-mode .gallery-entry-link { --gallery-entry-light: #ead28c; }
@media (hover: hover) and (pointer: fine) {
  .gallery-entry-link:hover { --gallery-door-scale: .55; --gallery-light-opacity: .35; }
}
</style>
